import rejectionApi from '../api/rejectionApi';

const getDefaultState = () => {
    return {
        teams: [],
        locations: [],
        varieties: [],
        sessions: []
    }
}

export default {
    namespaced: true,
    state: {
        teams: [],
        locations: [],
        varieties: [],
        sessions: []
    },
    getters: {
       
    },
    mutations: {
      
    },
    actions: {
        async resetState({ state }) {
            Object.assign(state, getDefaultState())
        },
        async loadMasterData({ state }, plantID) {
            var masterData = await rejectionApi.getMasterData(plantID); 
            state.teams = masterData.Teams;
            state.locations = masterData.Locations;
            state.varieties = masterData.Varieties;
        },
        async loadSessions({ state }, params) {
            state.sessions = await rejectionApi.getSessions(params.plantID, params.date, params.teamID, params.locationID, params.varietyID, params.barcode);
        },
        async updateRejectedPunnets({state}) {
            await rejectionApi.updateRejectedPunnets(state.sessions);
        },
        async exportToCSV(state, params) {
             await rejectionApi.exportToCSV(params.plantID, params.date, params.teamID, params.locationID, params.varietyID, params.barcode);
        },
    }
}

